export function sortArrayObjectsAlphabetically (key) {
    return function (objA, objB) {
        const strA = objA[key].toLowerCase()
        const strB = objB[key].toLowerCase()

        if (strA === strB) return 0
        return strA < strB ? -1 : 1
    }
}
